import React from 'react'

import { Button, IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const LinkButton = ({ isIconButton, children, to, ...restProps }) => {
    const navigate = useNavigate()
    const handleNavigate = (to) => () => navigate(to)

    if (isIconButton) {
        return (
            <IconButton {...restProps} onClick={handleNavigate(to)}>
                {children}
            </IconButton>
        )
    }

    return (
        <Button variant="contained" color="primary" {...restProps} onClick={handleNavigate(to)}>
            {children}
        </Button>
    )
}

export default LinkButton
